import axios from "axios";
import config from "../Config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;

const getReportList = (page, pagesize, search, ordering) => {
  try {
    return axios.get(`${API_URL}/api/${API_VERSION}/stock-verification/get-verified-bundles-datetime/`, {
      headers: authHeader(),
      params: {
        deleted: 0,
        page: page,
        pagesize: pagesize,
        search: search, // You might want to include search here, if applicable
        ordering: ordering
      },
    });
  } catch (error) {
    console.error('Error fetching die size list:', error);
    throw error; // Ensure this is thrown for proper handling elsewhere
  }
};

const getVerifiedByndleList = (page, pagesize, search, ordering) => {
  try {
    return axios.get(`${API_URL}/api/${API_VERSION}/stock-verification/get-verified-bundle/`, {
      headers: authHeader(),
      params: {
        deleted: 0,
        page: page,
        pagesize: pagesize,
        search: search, // You might want to include search here, if applicable
        ordering: ordering
      },
    });
  } catch (error) {
    console.error('Error fetching die size list:', error);
    throw error; // Ensure this is thrown for proper handling elsewhere
  }
};

const getVerifiedByndleListById = (report_id, page, pagesize, search, ordering) => {
  return axios.get(
    `${API_URL}/api/${API_VERSION}/stock-verification/get-verified-bundle/?report_id=${report_id}`,

    {
      headers: authHeader(),
      params: {
        deleted: 0,
        page: page,
        pagesize: pagesize,
        search: search, // You might want to include search here, if applicable
        ordering: ordering
      },
    }
  );
};




const getUnverifiedBundleList = (page, pagesize, search, ordering) => {
  try {
    return axios.get(`${API_URL}/api/${API_VERSION}/stock-verification/get-unverified-bundle/`, {
      headers: authHeader(),
      params: {
        deleted: 0,
        page: page,
        pagesize: pagesize,
        search: search, // You might want to include search here, if applicable
        ordering: ordering
      },
    });
  } catch (error) {
    console.error('Error fetching die size list:', error);
    throw error; // Ensure this is thrown for proper handling elsewhere
  }
};

const getUnVerifiedByndleListById = (report_id, page, pagesize, search, ordering) => {
  return axios.get(
    `${API_URL}/api/${API_VERSION}/stock-verification/get-unverified-bundle/?report_id=${report_id}`,

    {
      headers: authHeader(),
      params: {
        deleted: 0,
        page: page,
        pagesize: pagesize,
        search: search, // You might want to include search here, if applicable
        ordering: ordering
      },
    }
  );
};




const createSize = async (sizeData) => {
  try {
    const response = await axios.post(`${API_URL}/api/${API_VERSION}/}bundle-verification/verify-bundles/`, sizeData, {
      headers: authHeader(),
    });
    return response.data; // Assuming the response contains the created die size data
  } catch (error) {
    console.error('Error creating die size:', error);
    throw error; // Ensure proper error handling
  }
};
const editDieSize = (bundle_number) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/stock-verification/verify-bundles/?bundle_number=${bundle_number}`,
    {}, // optional body (send if needed)
    { headers: authHeader() }
  );
};

const editDieSizeTwo = (bundle_number, report_id) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/stock-verification/verify-bundles/?bundle_number=${bundle_number}&report_id=${report_id}`,
    {}, // optional body (send if needed)
    { headers: authHeader() }
  );
};
const deleteDieSize = (id) => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/die-size/${id}/archive/`, // Include the die group's ID in the URL
    {},
    { headers: authHeader() } // Authentication header
  );
};
const unArchiveDieSize = (id) => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/die-size/${id}/unarchive/`, // Include the die group's ID in the URL
    {}, // Pass an empty object if no data needs to be sent
    { headers: authHeader() } // Authentication header
  );
};


const dieSizeService = {
  getReportList,
  getVerifiedByndleList,
  getUnverifiedBundleList,
  createSize,
  editDieSize,
  deleteDieSize,
  unArchiveDieSize,
  getVerifiedByndleListById,
  getUnVerifiedByndleListById,
  editDieSizeTwo
};

export default dieSizeService;
